/* order_email_status.js — live SendGrid delivery confirmation for an order's
   outbound emails on the v2 ballot page. Subscribes to OrderEmailStatusChannel
   and updates a per-email status row each time a webhook event lands. */
document.addEventListener('turbolinks:load', () => {
  const panel = document.getElementById('order-email-status');
  if (!panel) return;
  if (!window.App || !window.App.cable) return;
  if (panel.dataset.subscribed === 'true') return;

  const orderId = panel.dataset.orderId;
  if (!orderId) return;

  const list      = document.getElementById('order-email-status-list');
  const emptyNote = document.getElementById('order-email-status-empty');
  const countEl   = document.getElementById('order-email-status-count');

  const STATUS_STYLES = {
    delivered: 'bg-green-100 text-green-800',
    processed: 'bg-blue-100 text-blue-800',
    deferred:  'bg-amber-100 text-amber-800',
    bounced:   'bg-red-100 text-red-800',
    failed:    'bg-red-100 text-red-800'
  };

  const esc = (str) =>
    (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;')
               .replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  const rowId = (ref) => 'oes-row-' + ref;

  function upsertRow(data) {
    if (!data.reference_id) return;

    if (emptyNote) emptyNote.classList.add('hidden');

    const badgeClass = STATUS_STYLES[data.send_status] || 'bg-gray-100 text-gray-700';
    const when = data.delivered_at || data.bounced_at || data.failed_at ||
                 data.deferred_at || data.last_event_at || '';
    const unit = data.unit_identifier ? ('Unit ' + esc(data.unit_identifier)) : esc(data.email_address);

    const inner = [
      '<div class="flex-1 min-w-0">',
        '<p class="text-sm font-medium text-gray-800 truncate">', unit || '&mdash;', '</p>',
        '<p class="text-xs text-gray-500 truncate">', esc(data.email_address), '</p>',
      '</div>',
      '<div class="flex items-center gap-3 flex-shrink-0">',
        '<span class="text-xs text-gray-400">', esc(when), '</span>',
        '<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ', badgeClass, '">',
          esc(data.send_status || data.last_event_type || 'pending'),
        '</span>',
      '</div>'
    ].join('');

    let row = document.getElementById(rowId(data.reference_id));
    if (!row) {
      row = document.createElement('div');
      row.id = rowId(data.reference_id);
      row.className = 'flex items-center gap-4 px-4 py-3 border-b border-gray-100 last:border-0';
      list.prepend(row);
    }
    row.innerHTML = inner;

    if (countEl) {
      countEl.textContent = list.querySelectorAll('[id^="oes-row-"]').length;
    }
  }

  window.App.cable.subscriptions.create(
    { channel: 'OrderEmailStatusChannel', order_id: orderId },
    {
      received(data) {
        if (data.type !== 'email_record_updated') return;
        upsertRow(data);
      }
    }
  );

  panel.dataset.subscribed = 'true';
});
